import React from "react";
import PresenceImmersion from "./PresenceImmersion";

export const MorningImmersion = () => <PresenceImmersion session="morning" />;

export default MorningImmersion;
